import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import Reveal from "@/components/Reveal";
import { CONTENT } from "@/content";

const FAQ = [
  {
    q: "L'ostéopathie fait-elle « craquer » ?",
    a: "Non, pas forcément. Je pratique une ostéopathie douce : la plupart des techniques se font sans aucune manipulation structurelle. Et quand un « craquement » est utile, il n'est jamais douloureux ni obligatoire — c'est simplement un dégagement gazeux articulaire, sans rapport avec l'efficacité du geste.",
  },
  {
    q: "Combien de séances faut-il prévoir ?",
    a: "Cela dépend de votre motif et de son ancienneté. Beaucoup de troubles récents s'améliorent en une à trois séances ; les douleurs installées demandent parfois un suivi un peu plus long. Nous faisons le point ensemble à chaque séance, en toute transparence.",
  },
  {
    q: "Les séances sont-elles remboursées ?",
    a: "L'ostéopathie n'est pas remboursée par l'Assurance Maladie, mais la plupart des mutuelles prennent en charge tout ou partie des séances. Une facture vous est remise à chaque consultation pour votre demande de remboursement.",
  },
  {
    q: "Combien dure une séance, et quel est le tarif ?",
    a: "Chaque séance dure environ 1 heure — première consultation ou suivi — et coûte 60 €. Le règlement se fait par chèque ou en espèces ; la carte bancaire n'est pas acceptée.",
  },
  {
    q: "Puis-je venir avec mon bébé ou mon enfant ?",
    a: "Bien sûr. Je reçois les nourrissons dès les premières semaines de vie (coliques, plagiocéphalie, troubles du sommeil…) avec des gestes extrêmement doux, ainsi que les enfants et adolescents. Mon mémoire de fin d'études portait d'ailleurs sur les enfants atteints de TDAH.",
  },
  {
    q: "Faut-il une ordonnance pour consulter ?",
    a: "Non. L'ostéopathe est un praticien de première intention : vous pouvez prendre rendez-vous directement, sans passer par votre médecin traitant.",
  },
  {
    q: "Comment se passe l'après-séance ?",
    a: "Il est fréquent de se sentir fatigué pendant 24 à 48 heures : le corps travaille et se réorganise. Je recommande de bien s'hydrater, de rester en mouvement en douceur et d'éviter les efforts intenses. Tout cela vous est expliqué pendant le bilan de fin de séance.",
  },
];

const Faq = () => (
  <section id="faq" className="relative overflow-hidden bg-ivory py-28 md:py-36" data-testid="faq-section">
    <div aria-hidden="true" className="wash wash-sage-light blob -right-[12%] top-[6%] h-[520px] w-[520px]" />
    <div className="relative mx-auto grid max-w-7xl grid-cols-1 gap-16 px-6 lg:grid-cols-12 lg:px-12">
      <div className="lg:col-span-4">
        <Reveal className="lg:sticky lg:top-32">
          <p className="text-xs font-medium uppercase tracking-[0.28em] text-gold">Questions fréquentes</p>
          <h2 className="mt-5 font-serif text-4xl font-light leading-tight tracking-tight text-anthracite md:text-5xl">
            Ce que l'on me demande <em className="text-sage-dark">avant de venir</em>
          </h2>
          <div className="gold-rule mt-8 w-24" />
          <p className="mt-8 text-base font-light leading-relaxed text-taupe">
            Une autre question ? Appelez-moi au{" "}
            <a href={`tel:${CONTENT.phone.replace(/\s/g, "")}`} className="font-medium text-anthracite underline decoration-sage underline-offset-4">
              {CONTENT.phone}
            </a>{" "}
            ou écrivez-moi — je réponds avec plaisir.
          </p>
        </Reveal>
      </div>

      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
            {FAQ.map((item, i) => (
              <AccordionItem key={i} value={`faq-${i}`} className="border-sage-light/60" data-testid={`faq-item-${i}`}>
                <AccordionTrigger
                  data-testid={`faq-question-${i}`}
                  className="py-6 font-serif text-lg font-light text-anthracite hover:text-sage-dark hover:no-underline md:text-xl [&>svg]:text-gold"
                >
                  {item.q}
                </AccordionTrigger>
                <AccordionContent data-testid={`faq-answer-${i}`} className="max-w-2xl text-base font-light leading-relaxed text-taupe">
                  {item.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </div>
  </section>
);

export default Faq;
